import { render, staticRenderFns } from "./ReChallengedDataTable.vue?vue&type=template&id=4d422a9b"
import script from "./ReChallengedDataTable.vue?vue&type=script&lang=js"
export * from "./ReChallengedDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports